var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareHandoutFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9486 0.741294C21.9404 0.667979 21.9241 0.594664 21.8997 0.52135V0.448035C21.859 0.358428 21.8101 0.276967 21.7368 0.211798C21.6716 0.138483 21.5902 0.089607 21.5005 0.0488765H21.4272C21.3539 0.0162922 21.2806 0 21.1991 0H21.1503C21.0688 0 20.9873 0.00814609 20.9059 0.0407304L0.556956 6.78569C0.271843 6.88344 0.0600445 7.12783 0.011168 7.42109C-0.0377085 7.71434 0.0763367 8.0076 0.304427 8.19497L7.7581 14.2068L13.7292 21.6604C13.884 21.856 14.1202 21.97 14.3646 21.97H14.5031C14.7963 21.9211 15.0407 21.7093 15.1385 21.4242L21.9079 1.0427C21.9241 0.961238 21.9241 0.879778 21.9079 0.798317L21.9486 0.741294ZM18.1199 2.64748L8.27945 12.488L2.48758 7.86097L18.1199 2.64748ZM14.0469 19.4366L9.4199 13.6447L19.2767 3.80422L14.0469 19.4366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHandoutFlight);
export default __webpack_public_path__ + "static/media/ShareHandoutFlight.2bb15d9ce9447040c51b2d13b104dc05.svg";
export { ForwardRef as ReactComponent };